$(document).ready(function(){  		
    //$('video').get(0).pause();	
  	cal_height();
	$(function() {
	    $('.home_banner_slick').slick({
	        autoplay: false,
	        autoplaySpeed: 3000,
	        draggable:true,
	        dots: true,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        arrows:false,
	   });
	    $('.home_banner_slick').show();
	});
  
    $(function() {
          $('.home_therapie_slick').slick({
              autoplay: true,
              autoplaySpeed: 3000,
              draggable:true,
              dots: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows:false,
              adaptiveHeight: true,
              responsive: [
                  {
                      breakpoint: 992,
                      settings:{
                          slidesToShow: 2,
                          slidesToScroll: 1
                      }
                  },
                  {
                      breakpoint: 481,
                      settings:{
                          slidesToShow: 1,
                          slidesToScroll: 1
                      }
                  }
              ]
         });
          $('.home_therapie_slick').show();
      });
  
    $(function() {
            $('.best_seller_items').slick({
                autoplay: true,
                autoplaySpeed: 3000,
                draggable:true,
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows:true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings:{
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings:{
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
           });
            $('.best_seller_items').show();
        });
  
  
    $(function() {
            $('.home_collections').slick({
                autoplay: false,
                autoplaySpeed: 3000,
                draggable:true,
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows:true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings:{
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                  	{
                        breakpoint: 481,
                        settings:{
                            slidesToShow: 1,
                            slidesToScroll: 1,
                          	arrows:false,
                          	autoplay: true
                        }
                    }
                ]
           });
            $('.home_collections').show();
        });
  
  		$(function() {
            $('.home_after_banner_icons').slick({
                autoplay: true,
                autoplaySpeed: 3000,
                draggable:true,
                dots: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows:true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings:{
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                  	{
                        breakpoint: 481,
                        settings:{
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }
                ]
           });
            $('.home_after_banner_icons').show();
        });
  		
  	 $(function() {
      $('.clinic_specialist_slick').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: true,
         nextArrow:'<img class="specialist_slick slick_right_arrow" src="https://cdn.shopify.com/s/files/1/0314/8693/5176/files/slick_pink_right_arrow.png?v=1584086481">',
         prevArrow:'<img class="specialist_slick slick_left_arrow" src="https://cdn.shopify.com/s/files/1/0314/8693/5176/files/slick_pink_left_arrow.png?v=1584086481">',
         fade: false,
         autoplay: false,       
      });
        $('.clinic_specialist_slick').show();
    });
  
  	$(function() {
      $('.featured_gal_sli').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: false,
         fade: true,
         asNavFor: '.thumbnail'
      });
      $('.slider-for').show();
    });
    $(function() {
      $('.thumbnail').slick({
         slidesToShow: 3,
         slidesToScroll: 1,
         asNavFor: '.featured_gal_sli',
         dots: false,
         arrows: true,
         nextArrow:'<img class="thumbnail_slick slick_right_arrow" src="https://cdn.shopify.com/s/files/1/0314/8693/5176/files/slick_pink_right_arrow.png?v=1584086481">',
         prevArrow:'<img class="thumbnail_slick slick_left_arrow" src="https://cdn.shopify.com/s/files/1/0314/8693/5176/files/slick_pink_left_arrow.png?v=1584086481">',
         focusOnSelect: true
      });
      $('.thumbnail').show();
    });
  	
  	$('.featured_gal_sli').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.slick-current iframe').attr('src', $('.slick-current iframe').attr('src'));
    });
  
  	 $('a[data-slide]').click(function(e) {
       e.preventDefault();
       var slideno = $(this).data('slide');
       $('.thumbnail').slick('slickGoTo', slideno - 1);
     });

  	var x = getCookie("first");
  	
    if(x != 'hello'){
      $('.announcement-bar').show();
    }else{
      $('.announcement-bar').hide();
    }

    function getCookie(name) {
        // Split cookie string and get all individual name=value pairs in an array
        var cookieArr = document.cookie.split(";");

        // Loop through the array elements
        for(var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");

            /* Removing whitespace at the beginning of the cookie name
            and compare it with the given string */
            if(name == cookiePair[0].trim()) {
                // Decode the cookie value and return
                return decodeURIComponent(cookiePair[1]);
            }
        }
        // Return null if not found
        return null;
    }
  	
});
$(window).on('load resize',function(){
	cal_height();
  	iframe_height();
});
function cal_height(){
	
  	$('.home_therapie_slick').on('setPosition', function () {
      $(this).find('.slick-slide').height('auto');
      var slickTrack = $(this).find('.slick-track');
      var slickTrackHeight = $(slickTrack).height();
      $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
    });
	
  var contact_form_right_height = $('.contact_form_right form').height();
  $('.contact_form_left form').height(contact_form_right_height);
}

$('.close_announcement button').on('click',function(){
	$('.announcement-bar').slideUp();
  	document.cookie = "first=hello";
});

$('.footer_logo').click(function(){
	window.location.replace("https://asoulspring.com/");
})

// $('.collection_name.has_dd').on('click',function(){
//   	$('.collection_name.has_dd').removeClass('active_collection_slide');
//   	$('.collection_products_sidebar').slideUp();
  
//   if($(this).hasClass('active_collection_slide')){
//   	$(this).removeClass('active_collection_slide');
//   }else{    
// 	$(this).addClass('active_collection_slide');
//   }
  
//   $('.active_collection_slide .collection_products_sidebar').slideDown();
// });

$('.collection_name.has_dd').hover(function(){
  	//$('.collection_name.has_dd').removeClass('active_collection_slide');
  	//$('.collection_products_sidebar').slideUp();
  
//   if($(this).hasClass('active_collection_slide')){
//   	$(this).removeClass('active_collection_slide');
//   }else{    
// 	$(this).addClass('active_collection_slide');
//   }
  $(this).addClass('active_collection_slide');
  
  $('.active_collection_slide .collection_products_sidebar').slideDown();
},function(){
	$('.collection_name.has_dd').removeClass('active_collection_slide');
});

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
  	var gt_class =  $(this).attr('class');
    if(gt_class != 'stop_animating'){
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
      }
});


$('input[type=radio][name=select_center]').change(function() {
  	var selected_center  = $(this).val();  
	$('#register_customer_tag').val(selected_center);
});

// $('input[type=radio][name=user_type]').change(function() {
// 	var user_type = $(this).val();
//   	if(user_type == "partners"){
//   		$('.company_field').fadeIn();
//     }else{
//     	$('.company_field').fadeOut();
//     }
// });

$('.contact_tabs li a').click(function(){
  	$('.contact_form_text').hide();
  	$('.contact_tabs li').removeClass('active');
  	$(this).parent().addClass('active');
	var user_type = $(this).text();
  	if(user_type == "For Partners"){
  		$('.company_field').fadeIn();
      	$('.contact_form_text.partner').show();
    }else{
    	$('.company_field').fadeOut();
      $('.contact_form_text.client').show();
    }
});

function iframe_height(){
    var slider_image_height = $('.slider.featured_gal_sli img').height();
    $('#slide_video').height(slider_image_height);
}
